import useSWR from 'swr'
export default function useUSDToggle() {
  const { data: state = false, mutate } = useSWR(
    'btc-usd-toggle', 
    null, 
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshWhenHidden: false,
      refreshWhenOffline: false,
    }
  );

  const setState = async (value: boolean): Promise<void> => { await mutate(value, false); };

  return [state, setState];
}